import { createContext } from 'react';
import { ScreenName } from 'common/utils/pp_tracking';
import { PostItemType } from 'service/timeline';

export type PostItemContextType = {
  post: PostItemType;
  screen: ScreenName | string;
  isSharedPost?: boolean;
};

export const PostItemContext = createContext<PostItemContextType>({
  post: {} as PostItemType,
  screen: ScreenName.HomeTimeline,
  isSharedPost: false,
});
